import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { FormPageTitle, ResourcesLoader } from 'omni-package-react-core';
import SecurityQuestionsForm from './SecurityQuestionsForm';
import SecurityQuestionsResource from '../../components/SecurityQuestionsResource';

export interface SecurityQuestionsFormPageProps { }

const SecurityQuestionsFormPage: FC<SecurityQuestionsFormPageProps> = () => {
  const { t } = useTranslation('SecurityQuestionsFormPage');
  return (

    <ResourcesLoader>
      <ResourcesLoader.Resources>
        <SecurityQuestionsResource autoRequest requestOnLanguageChange />
      </ResourcesLoader.Resources>
      <ResourcesLoader.Content>
        <FormPageTitle>{t('title')}</FormPageTitle>
        <SecurityQuestionsForm />
      </ResourcesLoader.Content>
    </ResourcesLoader>
  );
};

export default SecurityQuestionsFormPage;
